<template>
  <div class="min-h-screen flex">
    <nav class="w-64 bg-gradient-to-b from-green-800 to-green-950 text-white p-6 shadow-lg">
      <div class="mb-8 flex flex-col items-center text-center">
        <img src="@/assets/tnfd-logo.jpg" alt="TNFD Logo" class="w-20 h-20 object-contain mb-2 rounded-full bg-white p-1" />
        <h1 class="text-base font-bold leading-tight">Tamilnadu Forest Department</h1>
        <p class="text-green-300 text-xs mt-1">Animal Catching Operations</p>
      </div>

      <div class="mb-6 p-3 bg-green-700 bg-opacity-50 rounded-lg">
        <p class="font-semibold">{{ authStore.user?.full_name }}</p>
        <p class="text-green-300 text-xs capitalize">{{ authStore.user?.role }}</p>
      </div>

      <ul class="space-y-1">
        <li>
          <router-link to="/" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Dashboard
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/masters/staff" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Staff
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/masters/doctors" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Doctors
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/masters/surgeons" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Surgeons
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/masters/medicines" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Medicines
          </router-link>
        </li>
        <li class="border-t border-green-600 mt-4 pt-4">
          <router-link to="/operations/catchings" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Catchings
          </router-link>
        </li>
        <li>
          <router-link to="/operations/catchings/new" class="block px-4 py-2 rounded hover:bg-green-600 transition hover:bg-green-500">
            New Operation
          </router-link>
        </li>
        <li class="border-t border-green-600 mt-4 pt-4">
          <div class="px-4 py-2 text-xs font-semibold uppercase tracking-wide text-green-200">Settings</div>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/settings/districts" class="block px-4 py-2 pl-8 rounded hover:bg-green-700 transition">
            Districts
          </router-link>
        </li>
        <li>
          <router-link to="/settings/vehicles" class="block px-4 py-2 pl-8 rounded hover:bg-green-700 transition">
            Vehicles
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/settings/colours" class="block px-4 py-2 pl-8 rounded hover:bg-green-700 transition">
            Colours
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/settings/statuses" class="block px-4 py-2 pl-8 rounded hover:bg-green-700 transition">
            Status Master
          </router-link>
        </li>
        <li v-if="authStore.isAdmin">
          <router-link to="/settings/post-surgery-locations" class="block px-4 py-2 pl-8 rounded hover:bg-green-700 transition">
            Post Surgery Locations
          </router-link>
        </li>
        <li>
          <router-link to="/profile" class="block px-4 py-2 rounded hover:bg-green-700 transition">
            Profile
          </router-link>
        </li>
      </ul>

      <div class="mt-8 pt-4 border-t border-green-600">
        <button @click="logout" class="w-full px-4 py-2 bg-red-600 rounded hover:bg-red-700 transition">
          Logout
        </button>
      </div>
    </nav>

    <div class="flex-1 flex flex-col">
      <header class="bg-white shadow">
        <div class="px-6 py-4">
          <h2 class="text-2xl font-bold text-gray-800">{{ pageTitle }}</h2>
        </div>
      </header>
      <main class="flex-1 overflow-auto p-6">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

const pageTitle = computed(() => {
  const titles = {
    Dashboard: 'Dashboard',
    Districts: 'Districts',
    Vehicles: 'Vehicles',
    Staff: 'Staff Management',
    Doctors: 'Doctors',
    Colours: 'Dog Colours',
    Statuses: 'Status Master',
    PostSurgeryLocations: 'Post Surgery Locations',
    Surgeons: 'Surgeons',
    Medicines: 'Medicines',
    Catchings: 'Dog Catching Operations',
    NewCatching: 'New Catching Operation',
    EditCatching: 'Edit Catching Operation',
    CatchingDetail: 'Operation Details',
    Profile: 'Profile',
  }
  return titles[route.name] || 'Tamilnadu Forest Department'
})

const logout = () => {
  authStore.logout()
  router.push('/login')
}
</script>
